import { Field, Form, Formik } from 'formik';
import { Grid, MenuItem } from '@material-ui/core';
import { isNil } from 'ramda';
import React from 'react';
import { cFieldNames, validationSchema } from './taskNewSchema';
import { Language, languageInputEmpty } from '../../pages/Language/types';
import { IForm } from '../../types/IForm';
import { SubmitButton } from '../../components/Form/SubmitButton';
import FieldText from '../../components/Form/FieldText';
import { UserSearchField } from '../../components/Form/UserSearchField';
import FieldDate from '../../components/Form/FieldDatePicker/FieldDatePicker';
import useSWR from 'swr';
import { API_URL } from '../../apiTypes';
import { fetcher } from '../../apiUtils';
import FieldSelect from '../../components/Form/FieldSelect';
import { Loader } from '../../components/Loader/Loader';

interface Props extends IForm {
    onSubmit: (values: any) => void;
    buttonTitle: string;
    t: any;
}

export const TaskNewForm = ({ onSubmit, buttonTitle, userCanEdit, goBackUrl, t }: Props) => {
    const { data: safetyImpacts, isValidating: safetyImpactsValidating } = useSWR<string[]>(
        `${API_URL.COMMON_SAFETY_IMPACTS_LIST}`,
        fetcher
    );

    if (!safetyImpacts) return <Loader />;
    return (
        <Formik
            enableReinitialize
            initialValues={{}}
            validationSchema={validationSchema(t)}
            onSubmit={(values: any) => {
                onSubmit(values);
            }}
        >
            {({ handleChange, handleSubmit }) => (
                <Form onSubmit={handleSubmit} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} />
                        <Grid item xs={12} md={12} lg={12}>
                            <Field name={cFieldNames.solverNetId} component={UserSearchField} />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                fullWidth
                                name={cFieldNames.plannedActionDescription}
                                label={t('Tasks.new.plannedActionDescription')}
                                component={FieldText}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                fullWidth
                                name={cFieldNames.plannedDate}
                                label={t('Tasks.new.plannedDate')}
                                component={FieldDate}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                fullWidth
                                name={cFieldNames.actionSolvedDescription}
                                label={t('Tasks.new.actionSolvedDescription')}
                                component={FieldText}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                fullWidth
                                name={cFieldNames.actionSolvedDate}
                                label={t('Tasks.new.actionSolvedDate')}
                                component={FieldDate}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.safetyImpact}
                                label={t('Tasks.new.safetyImpact')}
                                fullWidth
                                component={FieldSelect}
                            >
                                <MenuItem value={undefined} key={0}>
                                    -
                                </MenuItem>
                                {safetyImpacts.map((safetyImpact: string, index: number) => (
                                    <MenuItem value={safetyImpact} key={index + 1}>
                                        {safetyImpact}
                                    </MenuItem>
                                ))}
                            </Field>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}></Grid>
                        <SubmitButton
                            visible={userCanEdit}
                            buttonTitle={buttonTitle}
                            goBackUrl={goBackUrl}
                        />
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};
